module.exports = __webpack_public_path__ + "static/img/product_society_society_yjgl4.13f8729.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product_society_society_yjgl4.svg
// module id = RQ8q
// module chunks = 0